import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function RotateIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3.4699 12.498C4.3899 13.224 5.4859 13.71 6.6379 13.903L6.9689 11.93C6.1469 11.792 5.3649 11.446 4.7089 10.927L3.4699 12.498Z" />
        <path d="M0.899902 8.166C1.0799 9.236 1.5149 10.266 2.1589 11.142L3.7699 9.956C3.3109 9.332 2.9999 8.598 2.8719 7.834L0.899902 8.166Z" />
        <path d="M0.899903 5.835L2.8729 6.165C3.0069 5.366 3.3399 4.602 3.8369 3.956L2.2509 2.737C1.5549 3.642 1.0879 4.713 0.899903 5.835Z" />
        <path d="M14.8029 7C14.8029 8.873 14.0439 10.65 12.7509 11.948L14.9029 14.1L8.5029 14.8L9.2029 8.4L11.3379 10.535C12.2609 9.607 12.8029 8.338 12.8029 7C12.8029 4.243 10.5599 2 7.8029 2C6.7429 2 5.7309 2.327 4.8749 2.947L3.7019 1.326C4.9019 0.459 6.3199 1.11963e-07 7.8029 0C11.6629 -2.91422e-07 14.8029 3.141 14.8029 7Z" />
      </svg>
    </Icon>
  );
}
